import { type FC, useEffect } from 'react'
import { useField, useFormikContext } from 'formik'
import CustomInput from './FormInput'
import { type Values } from '../../SignUpForm.interface'

interface StringLengthCheckInputProps {
  name: keyof Values;
  label: string;
  maxLength: number;
}

const StringLengthCheckInput: FC<StringLengthCheckInputProps> = ({ name, label, maxLength }) => {
  const [field] = useField<keyof Values>(name)
  const { setFieldError, setFieldTouched } = useFormikContext()

  const { value } = field
  const validate = (v: string): string => {
    const remainingChars = maxLength - v.length
    if (remainingChars < 0) {
      return `Exceeded maximum length of ${maxLength} characters`
    }

    return ''
  }

  useEffect(() => {
    const error = validate(field.value ?? '')
    if (error) {
      setFieldError(name, error)
      void setFieldTouched(name, true, false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.value])

  const strLength = value?.length ?? 0
  const remainingChars = Math.max(0, maxLength - strLength)

  return (
    <CustomInput
      as="textarea"
      rows={4}
      name={name}
      label={label}
      optionalText={`${remainingChars} characters remaining`}
    />
  )
}

export default StringLengthCheckInput
